<template>
  <Modal v-if="selectedItem" classs="template-modal" :cClass="'preview-template height-unlimit' + ` type-${type}`" hClass="" mClass="index-0" @cancel="closePreview" @keyup.esc="closePreview">
    <template #header></template>
    <div class="preview-header d-flex flex-direction-row align-items-center">
      <div class="d-flex justify-content-between align-items-center mr-2">
        <button class="btn preview-action text-light1" @click="previewPrev">
          <i class="icon icon-arrow-left"></i>
        </button>
        <button class="btn preview-action text-light1 ml-1" @click="previewNext">
          <i class="icon icon-arrow-right"></i>
        </button>
      </div>
      <h3 class="typo-heading16 typo-medium text-dark-high template-name" v-popover:tooltip.bottom="selectedName">
        {{ selectedName }}
      </h3>
      <Portal to="tooltips" v-if="reload">
        <transition name="fade">
          <Tooltip :pointer="true" :width="'auto'" />
        </transition>
      </Portal>
      <button class="btn preview-action ml-2 text-light1" v-popover:tooltip.bottom="$t('generals.share')" v-if="false">
        <i class="icon icon-share typo-icon-20" />
      </button>
      <div class="responsive">
        <button class="btn responsive-item" :class="{ active: screen == item.value }" :key="'res_' + item.value" v-for="item in responsives" @click="changeScreen(item.value)">
          <i class="icon typo-icon-20" :class="item.icon" />
        </button>
      </div>
      <div class="d-flex justify-content-between align-items-center ml-auto">
        <!-- <Dropdown
          :hideArrow="false"
          ref="dropdown"
          pclass
          bclass="btn-block gp_dropdown-button"
          :positioning="positioning"
          lclass
        >
          <template #button>Publish</template>

        </Dropdown> -->
        <template v-if="!hideEdit">
          <!-- <button class="btn btn-lg btn-primary mr-2 typo-button14 typo-medium btn-default" @click="showUpgradePopup" v-if="selectedItem.plan == 'professional' && !isStoreSeasonalAndHolidayTemplate">
            {{ $t("generals.buttons.upgradeToEdit") }}
          </button> -->
          <button class="btn btn-lg btn-primary mr-2 typo-button14 typo-medium btn-default" @click="selectTemplate" v-if="type == 'template'">
            {{ $t("generals.selectTemplate") }}
          </button>
        </template>
        <template v-else>
          <router-link :to="{ name: 'Pricing' }" class="btn btn-lg btn-primary mr-2 typo-button14 typo-medium btn-default" v-if="type == 'template'">{{ $t("generals.upgrade") }}</router-link>
        </template>

        <button class="btn preview-action action-close text-dark-high" @click="closePreview">
          <i class="icon icon-cancel"></i>
        </button>
      </div>
    </div>
    <div class="iframe-container">
      <div class="iframe-control" :style="controlSettings" ref="frameBound">
        <iframe :src="selectedDemo" frameborder="0" @load="closeLoading" ref="frame" id="gfFrame" :data-money="`\${{ amount }}`" :style="iframeSettings"></iframe>
        <GLoading size="large" class="frame-loader" v-if="loading" />
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

import { serverDomain } from "@/config/index.js";
import { DESIGNED_TEMPLATE_PREVIEW_EVENT } from "@/config/constants/trackEventIds";
import trackEvent, { TEMPLATE_INSERT_EVENT_ID } from "@/utils/tracker.js";

export default {
  name: "PreviewTemplate",
  props: {
    template: [String, Number],
    list: Array,
    hideEdit: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "template"
    }
  },
  data() {
    return {
      loading: false,
      item_id: null,
      screen: 1,
      reload: false,
      iframe: {
        width: 1366,
        height: 768,
        scale: 1,
        translate: 0
      },
      container: {
        width: 1366,
        height: 768
      }
    };
  },
  computed: {
    ...mapGetters("page", {
      getTemplate: "getTemplate",
      allTemplates: "allTemplates",
      getPage: "getPage",
      allPages: "allPages"
    }),
    ...mapGetters("account", {
      shopIsPro: "shopIsPro",
      isStoreSeasonalAndHolidayTemplate: "isStoreSeasonalAndHolidayTemplate",
    }),
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.isGemPagesV7) || window.___gemShopInfo.isGemPagesV7 || false;
    },
    previewLinkV7() {
      const previewUrl = this.selectedItem.themePageMetas.edges.find((x) => x.node.key === 'global_preview_url');
      return previewUrl?.node.value;
    },
    items() {
      if (this.type == "template") {
        let arr = JSON.parse(JSON.stringify(this.allTemplates));
        arr.sort((a, b) => {
          if (a.tags == this.type) return -1;
          if (b.tags == this.type) return 1;
          if (a.status && a.status.toLowerCase() == "soon") return 1;
          if (b.status && b.status.toLowerCase() == "soon") return -1;
        });
        return arr;
      } else {
        return this.allPages;
      }
    },
    selectedItem() {
      let output = null;
      // if (this.type == "template") output = this.getTemplate(this.item_id);
      // else if (this.type == "page") output = this.getPage(this.item_id);
      if (this.list && this.list.length) output = this.list.find(item => item.id == this.item_id);
      else output = this.items.find(item => item.id == this.item_id);
      return output;
    },
    selectedName() {
      if (this.type == "page") return this.selectedItem.title;
      return this.selectedItem.name;
    },
    selectedDemo() {
      if(this.isGemPagesV7 && this.previewLinkV7) {
        return this.previewLinkV7;
      }
      return `${serverDomain()}/proxy/templates/${this.selectedItem.id}/preview`
    },
    responsives() {
      return [
        {
          value: 1,
          type: "Desktop",
          icon: `icon-desktop`,
          width: "100%",
          breakpoint: 1366,
          maxWidth: null
        },
        {
          value: 2,
          type: "Laptop",
          icon: `icon-laptop`,
          width: "75%",
          breakpoint: 1024,
          maxWidth: 1335
        },
        {
          value: 3,
          type: "Tablet",
          icon: `icon-tablet`,
          width: "50%",
          breakpoint: 768,
          maxWidth: 1023
        },
        {
          value: 4,
          type: "Mobile",
          icon: `icon-mobile`,
          width: "375px",
          breakpoint: 320,
          maxWidth: 767
        }
      ];
    },
    selectedScreen() {
      let found = this.responsives.find(item => item.value == this.screen);
      return found || this.responsives[0];
    },
    iframeSettings() {
      let maxWidth = this.selectedScreen.maxWidth;
      let iframe = this.iframe;
      return {
        transform: `scaleX(${iframe.scale}) translateX(${iframe.translate})`,
        width: iframe.width,
        maxWidth: maxWidth != null ? `${maxWidth}px` : "unset",
        minWidth: this.selectedScreen.breakpoint
      };
    },
    controlSettings() {
      return {
        width: this.selectedScreen.width
      };
    }
  },
  watch: {
    template(newV) {
      this.item_id = newV;
      this.loading = true;
      this.reloadPortal();
    }
  },
  created() {
    this.item_id = this.template;
    this.loading = true;
    this.reloadPortal();
    window.addEventListener("resize", this.autoScale);
    this.trackViewedEvent();
  },
  mounted() {
    this.item_id = this.template;
    this.loading = true;
    this.reloadPortal();
    this.$nextTick(() => {
      this.autoScale();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.autoScale);
  },
  methods: {
    ...mapActions("page", {
      viewTemplate: "viewTemplate"
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    reloadPortal() {
      this.reload = false;
      setTimeout(() => {
        this.reload = true;
      }, 10);
    },
    openLoading() {
      this.loading = false;
    },
    closeLoading() {
      this.loading = false;
      if (this.type == "template") {
        this.viewTemplate({ id: this.item_id });
      }
    },
    selectTemplate() {
      this.$emit("select", this.template);
      trackEvent({
        eventId: TEMPLATE_INSERT_EVENT_ID,
        properties: {
          insert_template_id: this.template,
          insert_template_name: this.selectedName,
        }
      })
    },
    closePreview() {
      this.$emit("close");
    },
    showUpgradePopup() {
      this.$store.commit("account/SHOW_PLAN_MODAL");
    },
    switchTemplateCondition(item) {
      return this.isGemPagesV7 ? !item.themePageMetas.edges.find((x) => x.node.key === 'global_preview_url')?.node.value : !item.demo
    },
    previewNext() {
      let arr = this.items;
      if (this.list && this.list.length) {
        arr = this.list;
      }
      let ind = arr.findIndex(x => x.id == this.selectedItem.id);
      do {
        ind++;
        if (ind >= arr.length) ind = 0;
      } while (this.switchTemplateCondition(arr[ind]));
      const x = arr[ind];
      this.switch(x.id);
      this.reloadPortal();
    },
    previewPrev() {
      let arr = this.items;
      if (this.list && this.list.length) {
        arr = this.list;
      }
      let ind = arr.findIndex(x => x.id == this.selectedItem.id);
      do {
        ind--;
        if (ind < 0) ind = arr.length - 1;
      } while (this.switchTemplateCondition(arr[ind]));
      const x = arr[ind];
      this.switch(x.id);
      this.reloadPortal();
    },
    handleKey(event) {
      if (event && event.key === "Escape") this.closePreview();
    },
    switch(id) {
      this.item_id = id;
      this.loading = true;
      this.reloadPortal();
    },
    changeScreen(x) {
      this.screen = x;
    },
    autoScale() {
      let $bound = this.$refs.frameBound;
      let $frame = this.$refs.frame;

      if ($bound && $frame) {
        const _screen = this.selectedScreen;
        this.container.width = $bound.offsetWidth;
        this.container.height = $bound.offsetHeight;
        this.iframe.width = $frame.offsetWidth;
        this.iframe.height = $frame.offsetHeight;
        this.iframe.scale = 1;
        this.iframe.translate = 0;

        if ($bound.offsetWidth < _screen.breakpoint) {
          let scale = $bound.offsetWidth / _screen.breakpoint;
          let actualWidth = scale * this.container.width;
          let diff = this.container.width - actualWidth;
          // let widthCurrent = this.container.width * (1/scale);
          this.iframe.scale = scale;
          this.iframe.width = `${(1 / scale) * 100}%`;
          this.iframe.translate = `${(-(diff / 2) / actualWidth) * 100}%`;
        }
      }
    },
    trackViewedEvent() {
      const listIds = this.items.map(template => template.id);

      this.trackEvent({
        event_id: DESIGNED_TEMPLATE_PREVIEW_EVENT.VIEWED,
        properties: {
          designed_template: {
            id: this.selectedItem.id,
            name: this.selectedItem.name,
            tags: this.selectedItem.tags || "All",
            position: listIds.indexOf(this.selectedItem.id) + 1
          }
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
$height: 60px;
$padding-y: 10px;

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fade {
  &-enter-active {
    animation-name: fade;
    animation-duration: 0.5s;
  }

  &-leave-active {
    animation-name: fade;
    animation-duration: 0.5s;
    animation-direction: reverse;
  }
}

.iframe-container {
  z-index: -1;
  background: $light2;
  @include flex-center;
  .frame-loader {
    top: 0;
    left: 0;
    backdrop-filter: blur(34px);
    background: #ffffff80;
  }

  .iframe-control {
    position: relative;
    // transition: width 0.6s ease-in-out;
    transition: width 0.2s cubic-bezier(0.94, 0.24, 1, 1.21);
    iframe {
      width: 100%;
      height: calc(100vh - 60px);
      // position: absolute;
      // left: 0;
      // top: 0;
    }
  }
}

.template-name {
  width: 280px;
  max-width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.responsive {
  margin: -$padding-y calc(50vw - 172px / 2 - 128px - 280px) (-$padding-y) calc(50vw - 172px / 2 - 128px - 280px);
  @include flex-center;
  &-item {
    padding: 20px 10px;
    background: transparent;
    height: $height;
    color: $textDarkModeDisabled;

    ::v-deep svg {
      width: 20px;
      height: 20px;
    }
    &:not(:first-child) {
      margin-left: 4px;
    }

    &:hover {
      background: $dark3;
    }

    &.active {
      position: relative;
      color: $textDarkModeHigh;

      &:after {
        content: "";
        position: absolute;
        height: 2px;
        width: 100%;
        bottom: 0;
        left: 0;
        background: $light1;
      }
    }
  }
}

.preview-header {
  padding: $padding-y 24px;
  z-index: 10;
  background: $dark4;
}

.btn-default {
  min-width: 80px;
}

.preview-action {
  // padding: 12px;
  padding: 10px;
  font-size: 16px;
  border: $radius;
  background: transparent;
  $size: $height - 2 * $padding-y;
  width: $size;
  height: $size;
  svg {
    width: 20px;
    height: 20px;
  }
  &.action-close {
    font-size: 20px;
  }
  &:hover {
    background: $dark2;
  }
}
.template-modal {
  z-index: 999999;
}
</style>
